import { http } from '@/service';
import { ASSOCIATION_PREFIX_URL } from '@/constants';
import { NoticePageParamsModel } from '@/types';

/**
 * @description: 2103005 查看通知公告详情(接收者 【注意接口调用】)
 * @param bulletinId 公告id
 */
export const getNoticeDetail = (bulletinId: string): Promise<any> => {
  return http.post(`${ASSOCIATION_PREFIX_URL}/bulletin/read`, { bulletinId });
};

/**
 * @description: 2103006 获取接收到的通知公告列表
 * @param title 检索标题
 * @param size 每页显示条数，默认 10
 * @param current 当前页
 */
export const getNoticePage = (params: NoticePageParamsModel): Promise<any> => {
  return http.post(`${ASSOCIATION_PREFIX_URL}/bulletin/bulletinPage`, params);
};

/**
 * @description: hnf00101 律所需回执的通知列表（分页）
 */
export const firmPageApi = (params): Promise<any> => {
  return http.post(`${ASSOCIATION_PREFIX_URL}/mean/firmPage`, params);
};

/**
 * @description: hnf00102 律所查看需回执的通知详情
 */
export const meanViewApi = (params): Promise<any> => {
  return http.post(`${ASSOCIATION_PREFIX_URL}/mean/view`, params);
};

/**
 * @description: hnf00102 律所处理需要回执的通知收集资料上传
 */
export const collectApi = (params): Promise<any> => {
  return http.post(`${ASSOCIATION_PREFIX_URL}/mean/collect`, params);
};
/**
 * @description: 2103006 获取首页通知固定获取6条
 */
export const indexMsgApi = (params): Promise<any> => {
  return http.post(`${ASSOCIATION_PREFIX_URL}/bulletin/indexMsg`, params);
};